<div class="row pg-style">
  <div class="col-sm-12 pg-style">
    <div class="row search-banner">
      <div class="col-sm-12 search-banner-col">
        <h2 class="h3 search-banner-title">{{pageTitle}}</h2>
      </div>
    </div>
    <div class="row search-nav">
      <div class="col-sm-12 search-nav-col">
      </div>
    </div>
  </div>
</div>
<div class="row manage-user-or-auth-container">
    <div class="col-sm-12 card">
        @if (pageToShow === 'authorizations' && userInfo) {
        <bmt-view-auth [userInfo]="userInfo"></bmt-view-auth>
        }
    </div>
</div>
